module.exports = __webpack_public_path__ + "static/media/template.65aead13.xls";